import { useCallback } from 'react';
import { LinkerProps } from '../NavigationDrawerWide';
import {
  matchPath,
  RouteProps,
  useHistory,
  useLocation
} from 'react-router-dom';
import { useModalActions } from '../../Modals/modalActions';

export const useNavigationItem = (backUrl?: string) => {
  const history = useHistory();
  const location = useLocation<{ __from: string }>();
  const { openModal, activeModal } = useModalActions();

  const handleItemClick = useCallback(
    (item: LinkerProps, ev?: React.MouseEvent) => {
      if (item.onClick) {
        item.onClick(ev, openModal);
        return;
      }

      if (item.url) {
        if (typeof item.url === 'string' && item.url.match(/^http[s]?:\/\//)) {
          window.open(item.url, '_blank', 'noopener noreferrer');
        } else {
          const url = (item.url as RouteProps)?.path || item.url;
          history.push({
            pathname: url as string,
            state: {
              __from:
                backUrl ||
                (location.state && location.state.__from) ||
                location.pathname
            }
          });
        }
      }

      if (item.modal) {
        const modalData =
          typeof item.modalData === 'function'
            ? item.modalData({ location, backUrl }, item, matchPath)
            : item.modalData;
        openModal(item.modal, modalData);
      }
    },
    [history, location, backUrl, openModal]
  );

  const isActive = useCallback(
    (item: LinkerProps) => {
      const modalIsActive = activeModal && activeModal.modal === item.modal;
      return (
        item.active ||
        (item.url &&
          !item.matchUrl &&
          !!matchPath(location.pathname, item.url)) ||
        (item.matchUrl && !!matchPath(location.pathname, item.matchUrl)) ||
        modalIsActive
      );
    },
    [location, activeModal]
  );

  return {
    handleItemClick,
    isActive
  };
};
